export enum FedexServiceEnum {
  // Domestic Services
  PRIORITY_OVERNIGHT = "PRIORITY_OVERNIGHT",
  FEDEX_2_DAY = "FEDEX_2_DAY",
  STANDARD_OVERNIGHT = "STANDARD_OVERNIGHT",
  FIRST_OVERNIGHT = "FIRST_OVERNIGHT",
  FEDEX_EXPRESS_SAVER = "FEDEX_EXPRESS_SAVER",
  FEDEX_NEXT_DAY_EARLY_MORNING = "FEDEX_NEXT_DAY_EARLY_MORNING",
  FEDEX_NEXT_DAY_MID_MORNING = "FEDEX_NEXT_DAY_MID_MORNING",
  FEDEX_NEXT_DAY_AFTERNOON = "FEDEX_NEXT_DAY_AFTERNOON",
  FEDEX_NEXT_DAY_END_OF_DAY = "FEDEX_NEXT_DAY_END_OF_DAY",
  FEDEX_DISTANCE_DEFERRED = "FEDEX_DISTANCE_DEFERRED",
  FEDEX_1_DAY_FREIGHT = "FEDEX_1_DAY_FREIGHT",
  FEDEX_2_DAY_FREIGHT = "FEDEX_2_DAY_FREIGHT",
  FEDEX_3_DAY_FREIGHT = "FEDEX_3_DAY_FREIGHT",
  GROUND_HOME_DELIVERY = "GROUND_HOME_DELIVERY",
  FEDEX_GROUND = "FEDEX_GROUND",
  SAME_DAY_CITY = "SAME_DAY_CITY",
  FEDEX_FIRST = "FEDEX_FIRST",
  FEDEX_PRIORITY_EXPRESS = "FEDEX_PRIORITY_EXPRESS",
  FEDEX_PRIORITY = "FEDEX_PRIORITY",
  FEDEX_ECONOMY = "FEDEX_ECONOMY",
  FEDEX_PRIORITY_EXPRESS_FREIGHT = "FEDEX_PRIORITY_EXPRESS_FREIGHT",
  FEDEX_PRIORITY_FREIGHT = "FEDEX_PRIORITY_FREIGHT",
  // International Services
  INTERNATIONAL_PRIORITY = "INTERNATIONAL_PRIORITY",
  INTERNATIONAL_ECONOMY = "INTERNATIONAL_ECONOMY",
  INTERNATIONAL_FIRST = "INTERNATIONAL_FIRST",
  EUROPE_FIRST_INTERNATIONAL_PRIORITY = "EUROPE_FIRST_INTERNATIONAL_PRIORITY",
  INTERNATIONAL_PRIORITY_FREIGHT = "INTERNATIONAL_PRIORITY_FREIGHT",
  INTERNATIONAL_ECONOMY_FREIGHT = "INTERNATIONAL_ECONOMY_FREIGHT",
  FEDEX_INTERNATIONAL_PRIORITY = "FEDEX_INTERNATIONAL_PRIORITY",
  FEDEX_INTERNATIONAL_PRIORITY_EXPRESS = "FEDEX_INTERNATIONAL_PRIORITY_EXPRESS",
  FEDEX_INTERNATIONAL_CONNECT_PLUS = "FEDEX_INTERNATIONAL_CONNECT_PLUS",
  FEDEX_REGIONAL_ECONOMY = "FEDEX_REGIONAL_ECONOMY",
  FEDEX_REGIONAL_ECONOMY_FREIGHT = "FEDEX_REGIONAL_ECONOMY_FREIGHT",
}
